import Constants from '../actions/types';

const initialState = {
  matchingConfig: { fields: [] },
  loading: false,
  message: null,
  severity: null
};

const probMatchingReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.PROBMATCHCONFIG_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.PROBMATCHCONFIG_GET_SUCCESS: {
      let config = action.payload;
      if (!config.loggingByVectors) {
        config = {
          ...config,
          loggingByVectors: false,
          loggingByVectorsFraction: 0,
          loggingVectors: []
        };
      }
      if (!config.loggingByWeight) {
        config = {
          ...config,
          loggingByWeight: false,
          loggingByWeightLowerBound: 0,
          loggingByWeightUpperBound: 30
        };
      }
      const newState = {
        ...state,
        matchingConfig: config,
        loading: false
      };

      return newState;
    }

    case Constants.PROBLOGGEDPAIRCOUNTS_GET_SUCCESS: {
      const counts = action.payload;
      if (
        !counts ||
        !state.matchingConfig ||
        !state.matchingConfig.vectorConfig
      ) {
        return state;
      }

      const newVectorConfig = state.matchingConfig.vectorConfig.map(entry => {
        const key = entry.vectorValue.toString();
        const count = counts[key];
        const loggedLinkCount = count ? count : 0;
        return { ...entry, loggedLinkCount: loggedLinkCount };
      });

      const newState = {
        ...state,
        matchingConfig: {
          ...state.matchingConfig,
          vectorConfig: newVectorConfig
        }
      };
      return newState;
    }

    case Constants.PROBMATCHCONFIG_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.PROBMATCHCONFIG_SAVE_SUCCESS: {
      const newState = {
        ...state,
        message: 'Saved the matching configuration successfully.',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.PROBMATCHCONFIG_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.PROBMATCHCONFIG_REPLACE_SUCCESS: {
      let config = action.payload;
      if (!config.loggingByVectors) {
        config = {
          ...config,
          loggingByVectors: false,
          loggingByVectorsFraction: 0,
          loggingVectors: []
        };
      }
      if (!config.loggingByWeight) {
        config = {
          ...config,
          loggingByWeight: false,
          loggingByWeightLowerBound: 0,
          loggingByWeightUpperBound: 30
        };
      }
      const newState = {
        ...state,
        matchingConfig: config,
        loading: false
      };

      return newState;
    }
    case Constants.PROBMATCHCONFIG_REPLACE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.PROBMODEL_INIT_SUCCESS: {
      const newState = {
        ...state,
        message: 'Started the model initialization operation successfully.',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.PROBMODEL_INIT_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.RECORD_GENLINKS_SUCCESS: {
      const newState = {
        ...state,
        message:
          'Started the operation to reevaluate all records for matches successfully.',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.RECORD_GENLINKS_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.RECORD_LINKS_EVALPROBABLE_SUCCESS: {
      const newState = {
        ...state,
        message:
          'Started the operation to reevaluate all probable links successfully.',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.RECORD_LINKS_EVALPROBABLE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.LOGGED_PAIRS_DELETE_SUCCESS: {
      const newState = {
        ...state,
        message: 'Deleted all logged links successfully.',
        severity: 'info'
      };
      return newState;
    }

    case Constants.LOGGED_PAIRS_DELETE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };
      return newState;
    }

    case Constants.PROBMATCHCONFIG_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default probMatchingReducer;
